export default "/images/framework/Badge_05.780c4b13.svg?780c4b13";